import React, { useState } from "react";
import "./accordian.scss";

const Accordian = ({ title, children }) => {
  const [isActive, setIsActive] = useState(false);
  return (
    <div className="pricing-accordian-container">
      <div
        className={`pricing-accordian-title ${isActive ? "active" : ""}`}
        onClick={() => setIsActive((state) => !state)}
      >
        {title}
      </div>
      <div className="pricing-accordian-content">{children}</div>
    </div>
  );
};

export default Accordian;
